// extracted by mini-css-extract-plugin
export default {"container":"SideBarFooter_container__W2ijS","withBorder":"SideBarFooter_withBorder__hLc0Q"};